module.exports = __webpack_public_path__ + "img/w-xiuwei-nan.5e090054.jpg";